type GroupRecord = {
  elements: HTMLElement[],
  height: number
}

let windowEqualHeight = {
  resize: () => {},
}

let windowEqualHeightMobile = {
  resize: () => {},
}

function debounce(func: Function, wait: number) {
  let timeout: ReturnType<typeof setTimeout>
  return function () {
    clearTimeout(timeout)
    timeout = setTimeout(() => func(), wait)
  }
}

function getGroups(selector: string, attr: string): Record<string, GroupRecord> {
  const elements = document.querySelectorAll<HTMLElement>(selector)
  const groups: Record<string, GroupRecord> = {}

  elements.forEach((el) => {
    const name = el.getAttribute(attr) ?? ''
    if (!groups[name]) {
      groups[name] = { elements: [], height: 0 }
    }
    groups[name].elements.push(el)
  })

  return groups
}

function calculateHeights(groups: Record<string, GroupRecord>) {
  for (const key in groups) {
    groups[key].height = 0
    groups[key].elements.forEach((el) => {
      el.style.height = 'auto' // Reset first
      const height = el.offsetHeight
      if (height > groups[key].height) {
        groups[key].height = height
      }
    })
  }
}

function applyHeights(groups: Record<string, GroupRecord>) {
  for (const key in groups) {
    groups[key].elements.forEach((el) => {
      el.style.height = `${groups[key].height}px`
    })
  }
}

function equalHeight(): void {
  const groups = getGroups('[data-equal-height]', 'data-equal-height')

  if (Object.keys(groups).length === 0) return

  const resize = () => {
    calculateHeights(groups)
    applyHeights(groups)
  }

  resize()
  window.addEventListener('resize', debounce(resize, 200))
  windowEqualHeight.resize = resize
}

function equalHeightMobile(): void {
  const groups = getGroups('[data-equal-height-mobile]', 'data-equal-height-mobile')

  if (Object.keys(groups).length === 0) return

  const resize = () => {
    calculateHeights(groups)

    if (window.innerWidth < 768) {
      for (const key in groups) {
        groups[key].elements.forEach((el) => {
          el.style.height = 'auto'
        })
      }
    } else {
      applyHeights(groups)
    }
  }

  resize()
  window.addEventListener('resize', debounce(resize, 200))
  windowEqualHeightMobile.resize = resize
}

window.addEventListener('load', () => {
  equalHeight()
  equalHeightMobile()
})

export { equalHeight, equalHeightMobile }
